var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-empty-chart" },
    [
      _vm.loading
        ? _c("loading-wave")
        : _c(
            "a-empty",
            {
              scopedSlots: _vm._u([
                {
                  key: "image",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "material-icons empty-icon" }, [
                        _vm._v("insert_chart"),
                      ]),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "description",
                  fn: function () {
                    return [
                      _c("span", { staticClass: "empty-text" }, [
                        _vm._v(_vm._s(_vm.message)),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(" "),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("edit")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            " + _vm._s(_vm.buttonText) + "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }